import { gql } from "graphql-tag";

export const updateConfigSettingsMutation = gql`
mutation updateConfigSettings(
    $smtpHost: String,
    $smtpPort: String,
    $smptEmail: String,
    $smtpSender: String,
    $smtpSenderEmail: String,
    $smtpPassWord: String,
    $maxUploadSize: String,
    $stripePublishableKey: String,
    $fcmPushNotificationKey:String,
    $fcmApiKey: String,
    $fcmAuthDomain: String,
    $fcmProjectId: String,
    $fcmStorageBucket: String,
    $fcmMessagingSenderId: String,
    $fcmAppId: String,
    $fcmMeasurementId: String,
    $fcmVapidKey: String,
    $enableFirebase: String,
    $stripeSecretKey: String,
    $payPalClientId: String,
    $payPalSecret: String,
    $payPalHost: String,
    $googleMapBrowserApiKey:String
    $googleMapServerApiKey:String

) {
    updateConfigSettings(
        smtpHost: $smtpHost,
        smtpPort: $smtpPort,
        smptEmail: $smptEmail,
        smtpSender: $smtpSender,
        smtpSenderEmail: $smtpSenderEmail,
        smtpPassWord: $smtpPassWord,
        maxUploadSize: $maxUploadSize,
        stripePublishableKey: $stripePublishableKey,
        fcmPushNotificationKey:$fcmPushNotificationKey,
        fcmApiKey: $fcmApiKey,
        fcmAuthDomain : $fcmAuthDomain,
        fcmProjectId : $fcmProjectId,
        fcmStorageBucket: $fcmStorageBucket,
        fcmMessagingSenderId: $fcmMessagingSenderId,
        fcmAppId: $fcmAppId,
        fcmMeasurementId: $fcmMeasurementId,
        fcmVapidKey:  $fcmVapidKey,
        enableFirebase: $enableFirebase,
        stripeSecretKey: $stripeSecretKey,
        payPalClientId: $payPalClientId,
        payPalSecret: $payPalSecret,
        payPalHost: $payPalHost,
        googleMapBrowserApiKey:$googleMapBrowserApiKey
        googleMapServerApiKey:$googleMapServerApiKey
    ){
        status
        errorMessage
    }
}`;